module.exports = __webpack_public_path__ + "img/facebook.e74b895f.svg";